import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/pitch-roll/pitch-roll.js';
      import {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {PitchRollPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/pitch-roll/pitch-roll.js';

      export interface Props {
     pitch?: number;
     roll?: number;
     minAvgPitch?: number;
     maxAvgPitch?: number;
     minAvgRoll?: number;
     maxAvgRoll?: number;
     vesselImageFore?: VesselImage;
     vesselImageSide?: VesselImage;
     maxPitchAdvice?: number | undefined;
     maxRollAdvice?: number | undefined;
     triggerPitchAdvice?: boolean;
     triggerRollAdvice?: boolean;
     priority?: Priority;
     priorityElements?: PitchRollPriorityElement[]
   }

      
  
      export type {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {PitchRollPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/pitch-roll/pitch-roll.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPitchRoll',
  props: {
    pitch: {},
    roll: {},
    minAvgPitch: {},
    maxAvgPitch: {},
    minAvgRoll: {},
    maxAvgRoll: {},
    vesselImageFore: {},
    vesselImageSide: {},
    maxPitchAdvice: {},
    maxRollAdvice: {},
    triggerPitchAdvice: { type: Boolean },
    triggerRollAdvice: { type: Boolean },
    priority: {},
    priorityElements: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-pitch-roll',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})